import { withTranslation } from 'react-i18next';
import { Row, Col, Divider } from 'antd';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import {
  TwitterOutlined,
  InstagramOutlined,
  LinkedinOutlined,
  YoutubeOutlined
} from '@ant-design/icons';
import {
  twitter,
  youtube,
  linkedin,
  instagram,
  slideshare,
  flickr,
  pinterest,
  sistan,
  eurostat
} from 'config/links';
import PinterestLogo from 'assets/img/social/pinterest.png';
import SlideshareLogo from 'assets/img/social/slideshare.png';
import FlickrLogo from 'assets/img/social/flickr.png';

//import FooterLogo from 'assets/img/logo/logo_footer.png';
import FooterLogo from 'assets/img/logo/LogoIstatFooter.svg';
import { useGetSettings } from '../services/GetSettings';
import { useEffect } from 'react';
import { useState } from 'react';

function Footer({ isMobile }) {
  const { t } = useTranslation();
  const getSettings = useGetSettings();
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    (async () => {
      let res = await getSettings.execute();
      setSettings(res);
    })();
  }, []);

  return (
    <Row className="custom-footer">
      <Col xs={24} lg={6} className="istat-footer-logo">
        <a tabIndex={0}
            href="https://www.istat.it"
            target="_blank"
            rel="noreferrer">
          <img
            style={{ width: 'auto', height: '30px' }}
            className={isMobile ? 'mt-3' : ''}
            src={FooterLogo}
            alt="Logo ISTAT posizionato nel footer"
          /> 
        </a>
      </Col>
      <Col xs={24} lg={5} className="istat-footer-links">
        {!isMobile && <Divider className="d-none d-lg-block align-self-center" type="vertical" />}
        <div
          className={`d-flex w-100 flex-column FooterTop align-items-${
            !isMobile ? 'start' : 'center'
          }`}>
          <a
            href="https://www.istat.it/it/contatti"
            target="_blank"
            tabIndex={0}
            rel="noreferrer">
            {t('footer.contacts')}
          </a>
          <a href="https://www.istat.it/it/privacy" target="_blank" tabIndex={0} rel="noreferrer">
            {t('footer.privacy')}
          </a>
          <a
            href="https://www.istat.it/it/note-legali"
            target="_blank"
            tabIndex={0}
            rel="noreferrer">
            {t('footer.legal_notes')}
          </a>
          <a
            href={settings?.AccessibilityDeclarationUrl}
            target="_blank"
            tabIndex={0}
            rel="noreferrer">
            {t('footer.accessibility_declaration')}
          </a>
        </div>
      </Col>
      <Col xs={24} lg={5} className="FooterTop istat-footer-links">
        {!isMobile && <Divider className="d-none d-lg-block align-self-center" type="vertical" />}
        <div
          className={`d-flex w-100 flex-column FooterTop align-items-${
            !isMobile ? 'start' : 'center'
          }`}
          style={{ minHeight: '5.5rem' }}>
          <a href={sistan} target="_blank" tabIndex={0} rel="noreferrer">
            Sistan
          </a>
          <a href={eurostat} target="_blank" tabIndex={0} rel="noreferrer">
            Eurostat
          </a>
        </div>
      </Col>
      <Col xs={24} lg={7} className="istat-footer-socials m-0">
        {!isMobile && <Divider className="d-none d-lg-block align-self-center" type="vertical" />}
        <div
          className={`d-flex col-8 justify-content-between align-self-center`}>
          {/* Override FontAwesome Twitter to X */}
          <a href={twitter} aria-label="X" alt="X" tabindex="0">
            <svg aria-hidden="false" focusable="false" data-prefix="fab" data-icon="X" 
            class="svg-inline--fa svg-x-twitter fa-xl " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" alt="">
              <path fill="currentColor" 
              d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"></path>
            </svg>
          </a>
          {/* *** */}
          <a href={instagram} aria-label="Instagram" alt="Instagram" tabIndex={0}>
            <FontAwesomeIcon aria-hidden="false" alt="" icon={icon({ name: 'instagram', style: 'brands' })} size="xl" />
          </a>
          <a href={linkedin} aria-label="Linkedin" alt="Linkedin"  tabIndex={0}>
            <FontAwesomeIcon aria-hidden="false" alt="" icon={icon({ name: 'linkedin', style: 'brands' })} size="xl" />
          </a>
          <a href={youtube} aria-label="Youtube" alt="Youtube" tabIndex={0}>
            <FontAwesomeIcon aria-hidden="false" alt="" icon={icon({ name: 'youtube', style: 'brands' })} size="xl" />
          </a>
          <a href={flickr} aria-label="Flickr" alt="Flickr" tabIndex={0}>
            <FontAwesomeIcon aria-hidden="false" alt="" icon={icon({ name: 'flickr', style: 'brands' })} size="xl" />
          </a>
        </div>
      </Col>
      {process.env.NODE_ENV == 'local' &&
        <Col xs={24} lg={1} className="istat-footer-version d-flex">
          <div className="m-0">v{process.env.REACT_APP_VERSION}</div>
        </Col>}
    </Row>
  );
}

export default withTranslation()(Footer);
